/**
 * Check if a user has permission for a given module + action.
 * isSuperAdmin always returns true.
 * permissions is the object from Redux: { vaccines: ['read','create'], ... }
 */
export function hasPermission(isSuperAdmin, permissions, module, action) {
  if (isSuperAdmin) return true;
  if (!permissions || !module || !action) return false;
  return Array.isArray(permissions[module]) && permissions[module].includes(action);
}

/**
 * Check if user has any access to a module (at least 'read').
 */
export function canAccessModule(isSuperAdmin, permissions, module) {
  return hasPermission(isSuperAdmin, permissions, module, 'read');
}
